<template>
  <div>
    <div v-if="is_loading" class="loading"></div>
    <datatable
      title="Company Educations"
      @create="createEducation"
      @delete="deleteEducation"
      @edit_click="editClick"
      @override="override"
      @delete_all="deleteAll"
      :unique_buttons="unique_buttons"
      :fields="fields"
      :response="data"
    ></datatable>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import DataTable from '@/components/DataTable.vue'
export default {
  name: 'company-educations',
  data () {
    return {
      is_loading: false,
      fields: [
        {
          name: 'id',
          value: 'id'
        },
        {
          name: 'education_institution',
          value: 'education_institution.name'
        },
        {
          name: 'education_degree',
          value: 'education_degree.name'
        },
        {
          name: 'education_course',
          value: 'education_course.name'
        },
        {
          name: 'grade',
          value: 'grade'
        },
        {
          name: 'with_honors',
          value: 'with_honors'
        }
      ],
      data: [],
      operations: [],
      unique_buttons: [
        {
          name: 'override',
          display_text: 'Override Positions Educations'
        },
        {
          name: 'delete_all',
          display_text: 'Delete All Educations'
        }
      ],
      company_id: this.$route.query.company_id
    }
  },
  created: function () {
    this.init()
  },
  methods: {
    init () {
      this.$network_utils
        .getCompanyEducations({
          current_company_id: this.company_id
        })
        .then(response => {
          this.data = response
        })
    },
    override () {
      this.is_loading = true
      this.$network_utils.getCompanyPositions({ current_company_id: this.company_id }).then(response => {
        let get_positions_educations_requests = this.getPositionsEducationsRequests(response)
        this.$network_utils.caller.axios.all(get_positions_educations_requests).then(response => {
          let removal_requests = this.getRemovalRequests(response)
          this.$network_utils.caller.axios.all(removal_requests).then(() => {
            this.$utils.emit('show_toast', { text: 'override עבד בהצלחה' })
            this.is_loading = false
          })
        })
      })
    },
    getPositionsEducationsRequests (positions) {
      let requests = []
      for (let i = 0; i < positions.length; i++) {
        requests.push(this.$network_utils.getPositionEducations({ position_id: positions[i].id, current_company_id: this.company_id }))
      }
      return requests
    },
    getRemovalRequests (positions_educations) {
      let requests = []
      for (let i = 0; i < positions_educations.length; i++) {
        let position_educations = positions_educations[i]
        position_educations.map(education => {
          requests.push(this.$network_utils.deletePositionEducation({ id: education.id, position_id: education.resource.id, current_company_id: this.company_id }))
        })
      }
      return requests
    },
    deleteAll () {
      this.is_loading = true
      let requests = []
      for (let i = 0; i < this.data.length; i++) {
        requests.push(this.$network_utils.deleteCompanyEducation({ id: this.data[i].id, current_company_id: this.company_id }))
      }
      this.$network_utils.caller.axios.all(requests).then(() => {
        this.$utils.emit('show_toast', { text: 'כל ה- educations נמחקו בהצלחה' })
        this.is_loading = false
      })
    },
    deleteEducation (delete_data) {
      this.create({
        designator: 'delete-prompt',
        component_name: 'DeletePrompt',
        modal_title: 'Delete ' + delete_data.education_institution.name,
        item_name: delete_data.education_institution.name,
        method: 'deleteCompanyEducation',
        method_params: { id: delete_data.id, current_company_id: this.company_id }
      })
    },
    createEducation () {
      this.create({ designator: 'company-educations-form-modal', component_name: 'CompanyEducationsForm', is_create: true, company_id: this.company_id, modal_title: 'Create Company Educations' })
    },
    editClick (data) {
      this.create({ designator: 'company-educations-form-modal', component_name: 'CompanyEducationsForm', data, company_id: this.company_id, modal_title: data.education_institution.name })
    },
    ...mapMutations('modals', ['create'])
  },
  components: {
    datatable: DataTable
  }
}
</script>
<style scoped>
  .loading{
    margin-top: 30px;
    margin-left: 30px;
    margin-bottom: 30px;
  }
</style>
